import { HintAlert, TextArea } from '@epam/promo';
import { ReactComponent as NotificationIcon } from '@epam/assets/icons/common/notification-info-fill-24.svg';

import { RewardType } from 'store/recognition';
import css from '../FormBody.module.scss';
import { InlineLabelInput } from '../../../common';

const rewardHint = (value: string) => {
  switch (value) {
    case 'STICKER_PACK':
      return (
        <>
          <h5>How to add a sticker pack link to bot message:</h5>
          <p>
            1. Copy the URL of the sticker pack in Telegram by clicking on Share
            Stickers button
          </p>
          <p>2. Paste the stickers URL into the field above</p>
          <p>
            3. Save task for approve. User will receive stickers as a reward
            after completing entered amount of tasks
          </p>
        </>
      );
    case 'FEEDBACK_FORM':
      return (
        <>
          <h5>How to add a feedback link to bot message:</h5>
          <p>1. Copy the URL of the feedback form in Microsoft Forms</p>
          <p>2. Paste the form URL into the field above</p>
          <p>
            3. Save task for approve. User will receive feedback form after
            completing entered amount of tasks
          </p>
        </>
      );
    default:
      return '';
  }
};

interface RewardLinkProps {
  autoFocus: boolean;
  rewardValue: RewardType;
  value: string;
  isReadonly: boolean;
  errorMessage: string;
  onChange: (value: string, options?: { markAsDirty: boolean }) => void;
}

export const RewardLink = ({
  autoFocus,
  rewardValue,
  value,
  isReadonly,
  errorMessage,
  onChange,
}: RewardLinkProps) => (
  <InlineLabelInput
    isLink
    errorText={errorMessage}
    isReadonly={isReadonly}
    label="Link"
    readonlyValue={value}>
    <TextArea
      autoSize
      autoFocus={autoFocus}
      inputCx={{
        [css.textarea__input]: true,
        [css['textarea__input--error']]: !!errorMessage,
        [css.textarea__link]: isReadonly,
      }}
      isDisabled={isReadonly}
      placeholder="Add link"
      rawProps={{ 'data-testid': 'reward-link-input' }}
      size="48"
      value={value}
      onValueChange={onChange}
    />
    <HintAlert
      actions={[
        {
          name: rewardValue.actionLabel,
          action: () => window.open(rewardValue.link, '_blank'),
        },
      ]}
      cx={css.hint_alert}
      icon={NotificationIcon}>
      <div className={css.hint__text}>{rewardHint(rewardValue.value)}</div>
    </HintAlert>
  </InlineLabelInput>
);
